module.exports = __webpack_public_path__ + "static/media/logo.6d0f55b2.svg";